import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';  //  Import useParams
import config from './config.js';

function ResetPassword() {
    const { token } = useParams();  //  Get the token from the URL
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await fetch(`${config.backendUrl}/reset_password/${token}`, {  //  <---  Use the token
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ new_password: password }),  //  <---  Corrected body
            });
            const data = await response.json();
            setMessage(data.message);
            if (response.ok) {
                //  Redirect to login after successful password reset
                setTimeout(() => {
                    navigate('/login');
                }, 3000);  //  Redirect after 3 seconds
            }
        } catch (error) {
            console.error('An error occurred during password reset:', error);
            setMessage("An error occurred. Please try again.");
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                '& .MuiTextField-root': { m: 1, width: '30ch' }
            }}
        >
            <Typography variant="h5" component="h2">
                Reset Password
            </Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="New Password"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                />
                <Button
                    type="submit"
                    variant="contained"
                    sx={{ mt: 2 }}
                >
                    Submit
                </Button>
            </form>
            {message && <Typography variant="body1" sx={{ mt: 2 }}>{message}</Typography>}
        </Box>
    );
}

export default ResetPassword;